import * as React from 'react';
import { Button, UnavailableContentDialog } from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks';

import { useRouter } from 'next/router';
import { styled } from 'styled-components';

const Wrapper = styled.div`
  height: 100vh;
  > * {
    height: 100%;
    align-items: center;
  }
`;

interface CheckoutErrorProps {
  showRedirectButton?: boolean;
}

export function CheckoutError({ showRedirectButton = true }: CheckoutErrorProps) {
  const { data } = useBookingDraftQuery();
  const router = useRouter();
  const intl = useIntl();

  const error = data?.error;

  if (!error || (error && !error.hasError)) return null;

  const goToNextStep = () => {
    router.push(error.redirectUrl);
  };

  return (
    <Wrapper>
      <UnavailableContentDialog
        title={intl.formatMessage({ id: 'checkout_steps_error_title_text' })}
        message={intl.formatMessage({ id: 'checkout_steps_error_description_text' })}
      >
        {showRedirectButton && (
          <Button $hierarchy="primary" onClick={goToNextStep}>
            {intl.formatMessage({ id: `checkout_steps_error_go_to_${error.redirectTo}_button_text` })}
          </Button>
        )}
      </UnavailableContentDialog>
    </Wrapper>
  );
}
